module.exports = __webpack_public_path__ + "static/steel-erecting-and-cladding-11-5efd8073d3bb1ff7e3080409df7a4c4c.jpg";